import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModuleLabelKey, ModuleV1Read, UserInfo, VersionReadModel } from '@ca/core/models';
import { LinkService, UserService } from '@ca/core/services';
import { getModuleLabelKey } from '@ca/utils';
import { isInWorkspace } from '../../../../utils/route/route-utils';
import { PUBLIC_MODULES_ROUTE, USER_MODULES_ROUTE } from './../../constants/constants';

@Component({
    selector: 'ca-module-item',
    templateUrl: './module-item.component.html',
    styleUrls: ['./module-item.component.scss'],
})
export class ModuleItemComponent {
    @Input() module: ModuleV1Read;
    @Input() showBanner = false;
    @Input() shownVersion: VersionReadModel;

    get userInfo(): UserInfo | undefined {
        return this.userService.myInfo;
    }

    get isLoggedIn(): boolean {
        return this.userService.isLoggedIn;
    }

    get isInWorkspace(): boolean {
        return isInWorkspace(this.router.url);
    }

    get detailLink(): string[] {
        let detailLink: string[] = [];
        if (this.module != null) {
            const { title, id } = this.module;

            if (this.isInWorkspace && (this.isMine || this.isShared)) {
                detailLink = this.linkService.getDetailLinkAsArray(USER_MODULES_ROUTE, title, id);
            } else {
                detailLink = this.linkService.getDetailLinkAsArray(PUBLIC_MODULES_ROUTE, title, this.module.id);
            }
        }
        return detailLink;
    }

    get profileLink(): Array<string> {
        let profileLink: string[] = [];
        if (this.module && this.module.author && this.module.author.id) {
            profileLink = ['/user/profile', this.module.author.id];
        }

        return profileLink;
    }

    get moduleLabelKey(): ModuleLabelKey | undefined {
        return getModuleLabelKey(this.module, this.userInfo?.sub);
    }

    private get isMine(): boolean {
        let isMine = false;

        if (this.module != null && this.module.producerId != null && this.userInfo != null) {
            isMine = this.module.producerId === this.userInfo.sub;
        }
        return isMine;
    }

    private get isShared(): boolean {
        if (this.userInfo != null && this.module.shares.length > 0) {
            return !!this.module.shares.find(share => share.userId === this.userInfo!.sub);
        }
        return false;
    }

    get isCompliant(): boolean {
        if (this.module?.latestPublicVersion?.compliances) {
            return this.module.latestPublicVersion?.compliances.length > 0;
        }
        return false;
    }

    get showRibbon(): boolean {
        return this.module.isFeatured || (this.isCompliant && !this.module.isFeatured);
    }

    constructor(
        private linkService: LinkService,
        private router: Router,
        private userService: UserService,
    ) {}
}
